import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getTournamentMatches = async (tournamentId) => {
    try {
        const response = await axios.get(`${API_URL}tournament/points/${tournamentId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export { getTournamentMatches };